import type { ReactNode } from "react"

import { ThumbnailsContainer, ThumbnailsLi, ThumbnailsUl } from "./styled"
import ThumbnailButton from "./ThumbnailButton"

export interface CarouselThumbnailsProps {
  readonly activeIndex: number
  readonly columnGap: number
  readonly isShowThumbnails: boolean
  readonly name?: string
  readonly onSelectIndex: (index: number) => void
  readonly onThumbnailPress?: (index: number) => void
  readonly thumbnails: ReactNode[]
  readonly thumbnailsContainerRef: React.RefObject<HTMLDivElement | null>
}

const CarouselThumbnails = ({
  activeIndex,
  columnGap,
  isShowThumbnails,
  name,
  onSelectIndex,
  onThumbnailPress,
  thumbnails,
  thumbnailsContainerRef
}: CarouselThumbnailsProps) =>
  !isShowThumbnails || thumbnails.length === 0 ? null : (
    <ThumbnailsContainer
      aria-label={name ? `${name} Thumbnails` : "Carousel Thumbnails"}
      ref={thumbnailsContainerRef}
    >
      <ThumbnailsUl
        $columnGap={columnGap}
        aria-label={
          name ? `${name} Thumbnails List` : "Carousel Thumbnails List"
        }
      >
        {thumbnails.map((thumb, index) => (
          <ThumbnailsLi
            aria-label={
              name
                ? `${name} Thumbnails Item ${index}`
                : `Carousel Thumbnails Item ${index}`
            }
            data-thumb-index={index}
            // eslint-disable-next-line react/no-array-index-key
            key={`${name ?? "carousel"}-thumbnail-${index}`}
            role="listitem"
          >
            <ThumbnailButton
              activeIndex={activeIndex}
              index={index}
              onSelectIndex={onSelectIndex}
              onThumbnailPress={onThumbnailPress}
            >
              {thumb}
            </ThumbnailButton>
          </ThumbnailsLi>
        ))}
      </ThumbnailsUl>
    </ThumbnailsContainer>
  )

export default CarouselThumbnails
